import { render, staticRenderFns } from "./AddEventModal.vue?vue&type=template&id=12b0d09e"
import script from "./AddEventModal.vue?vue&type=script&lang=js"
export * from "./AddEventModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12b0d09e')) {
      api.createRecord('12b0d09e', component.options)
    } else {
      api.reload('12b0d09e', component.options)
    }
    module.hot.accept("./AddEventModal.vue?vue&type=template&id=12b0d09e", function () {
      api.rerender('12b0d09e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/comUi/AddEventModal.vue"
export default component.exports